import { Hint } from '@/Ship/Components/Hint'
import { CheckGlobalResourceAccessTask } from '@/Ship/Tasks/CheckGlobalResourceAccessTask'

import { ACTIVITY_RESOURCE } from '../Contracts/Activity.types'

/**
 * Пояснення над реєстром «Справи» (`SPEC-011` §11, ADR 017): чому рядок
 * червоний і чиї справи в списку. Друге — лише тому, хто бачить не всі
 * справи (без колекційного `read_all`): адміністратору воно нічого не каже.
 *
 * Тексти звірено з кодом: червоне — предикат П (§5.1), «відповідальний або
 * автор» — правило рядка `ActivityRule` (§10), бейдж меню — лічильник
 * `OverdueActivityCounter` (той самий П, лише справи, де відповідальний —
 * поточний користувач; S6b).
 */
export const ActivityRegistryHints = () => (
    <>
        <Hint id="crm.activities.overdue">
            Червоним позначено незавершені справи, крайній термін яких уже настав. Бейдж «Справи» в меню показує,
            скільки таких справ, де відповідальний — ви.
        </Hint>
        {!CheckGlobalResourceAccessTask(ACTIVITY_RESOURCE, 'read_all') ? (
            <Hint id="crm.activities.scope">
                У списку — справи, де ви відповідальний або автор. Справи всіх співробітників бачить адміністратор.
            </Hint>
        ) : null}
    </>
)
